import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectIsLoggedIn } from "../Redux/authSlice";
import { useAuth } from "../context/AuthContext";
import Loader from "../component/Loader/Loader";

const ProtectedRoute = ({ children }) => {
  const isLoggedIn = useSelector(selectIsLoggedIn);
  const { loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <Loader />;
  }

  if (!isLoggedIn) {
    // Remember where the user was headed so we can send them back there after
    // login (carried through OAuth via the `state` param — see LoginNew).
    const returnTo = location.pathname + location.search;
    return (
      <Navigate
        to={`/login?returnTo=${encodeURIComponent(returnTo)}`}
        replace
      />
    );
  }

  return children;
};

export default ProtectedRoute;
